<!-- Read-only: the owner chooses each website's build mode in the website builder (FR-55.2); support reads it here. -->
<section class="panel">
  <div class="section-header">
    <h3>Websites</h3>
    @if (autonomousCount) {
      <span class="pill pill-purple pill-sm" title="Websites Plus builds and publishes on its own">{{ autonomousCount }} autonomous</span>
    }
  </div>

  @if (loading) {
    <span class="muted">Loading websites…</span>
  } @else if (unavailable) {
    <span class="muted">{{ unavailable }}</span>
  } @else if (error) {
    <span class="muted">{{ error }}</span>
  } @else if (!rows.length) {
    <span class="muted">No website has a build mode set: every website of this business builds in {{ defaultModeLabel }} — Plus drafts, people review and publish.</span>
  } @else {
    <div class="tbl-wrap sites-tbl">
      <table class="tbl">
        <thead>
          <tr>
            <th>Website</th>
            <th>Build mode</th>
            <th>Set by</th>
            <th>When</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.siteId ?? $index) {
            <tr>
              <td>
                <span class="site-name">{{ siteLabel(row) }}</span>
                @if (row.siteName && row.siteId) { <span class="muted mono site-id"> · {{ row.siteId }}</span> }
              </td>
              <td>
                <span [class]="modePill(modeOf(row)) + ' pill-sm'">{{ modeLabel(modeOf(row)) }}</span>
                @if (modeHint(modeOf(row)); as hint) { <span class="muted mode-hint">{{ hint }}</span> }
              </td>
              <td class="mono">{{ row.updatedBy || '—' }}</td>
              <td>
                @if (row.updatedAt) { {{ row.updatedAt | date:'medium' }} } @else { — }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <p class="muted note-line">
    Read-only. Websites not listed build in {{ defaultModeLabel }}. Automatic publishes and fallbacks to review show on each execution under Agents.
  </p>
</section>
